import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import { RichContent } from '../../../RichContent/RichContent';

type DescriptionProps = ComponentProps<'p'> & { text: string };

/**
 * A component that renders a description. Used in the FaqSection component.
 * @param text - The text of the description.
 * @param className - The class name of the description.
 * @param props - The props of the description.
 * @returns The description component.
 */
function Description({ text, className, ...props }: DescriptionProps) {
  return <RichContent className={twMerge('text-foreground-subtle', className)} information={text} tag="p" {...props} />;
}

export { Description };
